import { apiClient } from "./client";
import type { AuthToken, LoginCredentials, User } from "../types/index.js";

export const authApi = {
  login: async (credentials: LoginCredentials): Promise<AuthToken> => {
    console.log("[authApi] Sending login request to /auth/login");
    const response = await apiClient.post<AuthToken>(
      "/auth/login",
      credentials,
    );
    console.log("[authApi] Login response received:", response.status);
    return response.data;
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await apiClient.get<User>("/auth/me");
    return response.data;
  },

  changePassword: async (currentPassword: string, newPassword: string): Promise<void> => {
    await apiClient.post('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
  },

  requestPasswordReset: async (email: string): Promise<void> => {
    await apiClient.post("/auth/forgot-password", { email });
  },

  resetPassword: async (token: string, newPassword: string): Promise<void> => {
    await apiClient.post("/auth/reset-password", {
      token,
      new_password: newPassword,
    });
  },

  acceptInvitation: async (
    token: string,
    newPassword: string,
  ): Promise<void> => {
    await apiClient.post("/auth/accept-invitation", {
      token,
      new_password: newPassword,
    });
  },

  validateInvitation: async (
    token: string,
  ): Promise<{
    valid: boolean;
    email: string | null;
    full_name: string | null;
    expired: boolean;
    already_accepted: boolean;
    revoked: boolean;
    reason: string | null;
  }> => {
    const response = await apiClient.get("/auth/validate-invitation", {
      params: { token },
    });
    return response.data;
  },
};
